import { useQuery } from '@tanstack/react-query';
import { useSite } from '../../../../context/page-context';
import { useAccountApi } from '../../hooks/use-settings-api';

export const QK_ACCOUNT_TEAM_SELECT_PLAN_URL = (teamId: number | undefined) =>
  ['account-team-select-plan-url', teamId] as const;

export function useSelectPlanURL() {
  const { accountApi } = useAccountApi();
  const { teamId } = useSite();

  return useQuery({
    queryKey: QK_ACCOUNT_TEAM_SELECT_PLAN_URL(teamId),
    queryFn: () => accountApi.team(teamId).selectPlanURL(),
    retry: false,
  });
}
